import { Container, Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';

import { useAuthStore } from '@modules/auth/store';

import { useNavigate } from '@core/hooks/navigate.hook';
import { Routes } from '@core/constants/routes';

export default function ActivitiesLayout() {
  const navigate = useNavigate();

  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    if (!user?.activeCheckin?.campaign) {
      navigate([Routes.CHECKIN]);
    }
  }, [user]);

  return (
    <Container sx={{ px: 0, height: '100%' }} maxWidth='sm' component={Stack}>
      <Outlet />
    </Container>
  );
}
